var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
	var len = len - (s + '').length;
	for (var i = 0; i < len; i++) {
		s = '0' + s;
	}
	return s;
};

function Base64() {

	// private property
	let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

	// public method for encoding
	this.encode = function(input) {
		var output = "";
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
		var i = 0;
		input = this._utf8_encode(input);
		while (i < input.length) {
			chr1 = input.charCodeAt(i++);
			chr2 = input.charCodeAt(i++);
			chr3 = input.charCodeAt(i++);
			enc1 = chr1 >> 2;
			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
			enc4 = chr3 & 63;
			if (isNaN(chr2)) {
				enc3 = enc4 = 64;
			} else if (isNaN(chr3)) {
				enc4 = 64;
			}
			output = output +
				_keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
				_keyStr.charAt(enc3) + _keyStr.charAt(enc4);
		}
		return output;
	}

	// public method for decoding
	this.decode = function(input) {
		var output = "";
		var chr1, chr2, chr3;
		var enc1, enc2, enc3, enc4;
		var i = 0;
		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
		while (i < input.length) {
			enc1 = _keyStr.indexOf(input.charAt(i++));
			enc2 = _keyStr.indexOf(input.charAt(i++));
			enc3 = _keyStr.indexOf(input.charAt(i++));
			enc4 = _keyStr.indexOf(input.charAt(i++));
			chr1 = (enc1 << 2) | (enc2 >> 4);
			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
			chr3 = ((enc3 & 3) << 6) | enc4;
			output = output + String.fromCharCode(chr1);
			if (enc3 != 64) {
				output = output + String.fromCharCode(chr2);
			}
			if (enc4 != 64) {
				output = output + String.fromCharCode(chr3);
			}
		}
		output = this._utf8_decode(output);
		return output;
	}

	// private method for UTF-8 encoding
	this._utf8_encode = function(string) {
		string = string.replace(/\r\n/g, "\n");
		var utftext = "";
		for (var n = 0; n < string.length; n++) {
			var c = string.charCodeAt(n);
			if (c < 128) {
				utftext += String.fromCharCode(c);
			} else if ((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			} else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}

		}
		return utftext;
	}

	// private method for UTF-8 decoding
	this._utf8_decode = function(utftext) {
		var string = "";
		var i = 0;
		var c = c1 = c2 = 0;
		while (i < utftext.length) {
			c = utftext.charCodeAt(i);
			if (c < 128) {
				string += String.fromCharCode(c);
				i++;
			} else if ((c > 191) && (c < 224)) {
				c2 = utftext.charCodeAt(i + 1);
				string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
				i += 2;
			} else {
				c2 = utftext.charCodeAt(i + 1);
				c3 = utftext.charCodeAt(i + 2);
				string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
				i += 3;
			}
		}
		return string;
	}
}


export default {
	/**
	 * @description 返回时间范围中的时间
	 * @param {Array} dateRang 时间
	 * @param {Number} index 下标
	 */
	getDate(dateRang, index) {
		return dateRang == '' || dateRang == null ? null : dateRang[index];
	},
	getQueryStringByName: function(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		var context = "";
		if (r != null)
			context = r[2];
		reg = null;
		r = null;
		return context == null || context == "" || context == "undefined" ? "" : context;
	},
	formatDate: {
		format: function(date, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			return pattern.replace(SIGN_REGEXP, function($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		formatString: function(value, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			var reg = /^(\d{4})(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2}) */;
			if (!reg.test(value) && RegExp.$3 <= 12 && RegExp.$5 <= 31) {
				return "";
			}
			let date = new Date(value);
			return pattern.replace(SIGN_REGEXP, function($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		parse: function(dateString, pattern) {
			var matchs1 = pattern.match(SIGN_REGEXP);
			var matchs2 = dateString.match(/(\d)+/g);
			if (matchs1.length == matchs2.length) {
				var _date = new Date(1970, 0, 1);
				for (var i = 0; i < matchs1.length; i++) {
					var _int = parseInt(matchs2[i]);
					var sign = matchs1[i];
					switch (sign.charAt(0)) {
						case 'y':
							_date.setFullYear(_int);
							break;
						case 'M':
							_date.setMonth(_int - 1);
							break;
						case 'd':
							_date.setDate(_int);
							break;
						case 'h':
							_date.setHours(_int);
							break;
						case 'm':
							_date.setMinutes(_int);
							break;
						case 's':
							_date.setSeconds(_int);
							break;
					}
				}
				return _date;
			}
			return null;
		}

	},
	//返回格式:yyyy-MM-dd (4.0复制过来的)
	foDate: function(value) {
		if (value == null || value == '') {
			return '';
		}
		var dt;
		if (value instanceof Date) {
			dt = value;
		} else {
			if (value.indexOf("Date") >= 0) {
				dt = new Date(value);
				if (isNaN(dt)) {
					value = value.replace(/\/Date\((-?\d+)\)\//, '$1');
					dt = new Date();
					dt.setTime(value);
					var b = dt.format("yyyy-MM-dd")
				}
			} else {
				var reg = new RegExp('/', "g"); //g,全部替换。            
				var dtArr = value.replace(reg, '-').substr(0, 10).split("-");
				var b = dtArr[0] + "-" + dtArr[1] + "-" + dtArr[2];
			}
		}
		if ((b == '1-01-01') || (b == '0001-01-01') || (b == '1901-01-01') || (b == '1900-01-01'))
			b = '';
		return b;
	},
	//返回格式:yyyy-MM-dd hh:mm:ss (4.0复制过来的)
	foDateTime: function(value) {
		if (value == null || value == '') {
			return '';
		}
		//序列化后的日期格式
		if (value.indexOf('Date') > -1) {
			var dt;
			if (value instanceof Date) {
				dt = value;
			} else {
				dt = new Date(value);
				if (isNaN(dt)) {
					value = value.replace(/\/Date\((-?\d+)\)\//, '$1'); //标红的这段是关键代码，将那个长字符串的日期值转换成正常的JS日期格式
					dt = new Date();
					dt.setTime(value);
				}
			}
		} else {
			//非序列化日期格式
			var b = value.replace("T", " ").substring(0, 16);
			var tmpstr = b.substring(0, 4);
			if (tmpstr == "1900" || tmpstr == "1901" || tmpstr == "0001") {
				return "";
			} else {
				return b;
			}
		}
		var b = dt.format("yyyy-MM-dd")
		if ((b == '0001-01-01') || (b == '1-01-01') || (b == '1901-01-01') || (b == '1900-01-01')) {
			b = '';
		} else {
			b = dt.format("yyyy-MM-dd hh:mm");
		}
		return b;
	},
	objTrim(form) {
		if (typeof(form) == "string") {
			form = form.trim()
		} else {
			for (var key in form) {
				if (typeof(form[key]) == "string") {
					form[key] = form[key].trim()
				}
			}
		}
		return form
	},
	//去左空格;
	ltrim(s) {
		if (s == undefined) return '';
		if (s == '') return s;
		return s.replace(/(^\s*)/g, "");
	},
	//去右空格;
	rtrim(s) {
		if (s == undefined) return '';
		if (s == '') return s;
		return s.replace(/(\s*$)/g, "");
	},
	//去左右空格;
	trim(s) {
		if (s == undefined) return '';
		if (s == '') return s;
		return s.replace(/(^\s*)|(\s*$)/g, "");
	},
	//密码校验
	isPwd(pwd) {
		var re = /^(?=.*[a-z])(?=.*\d)[^]{6,16}$/;
		var result = re.test(pwd);
		if (!result) {
			return false;
		} else {
			return true;
		}
	},
	mounted() {
		// this.$com.initPage();
	},
	tree: function(d, leaf) {
		leaf.forEach(ele => {
			if (ele.id === d.pid) {
				ele.children.push({
					id: d.navigationid,
					label: d.nodename,
					children: [],
					navigationid: d.navigationid,
					pnodeid: d.pnodeid,
					nodename: d.nodename,
					type: d.type,
					describes: d.describes,
					expscript: d.expscript,
					sqlscript: d.sqlscript,
          sqlscriptvalidate:d.sqlscriptvalidate,
					FatherName: ele.label,
					icon: d.type == 0 ? 'el-icon-search' : 'el-icon-folder',
				})
			} else {
				this.tree(d, ele.children)
			}
		})
	},
	tree_init: function(d, leaf) {
		d.forEach(ele => {
			if (ele.pid == -1) {
				leaf.push({
					id: ele.navigationid,
					label: ele.nodename,
					children: [],
					navigationid: ele.navigationid,
					pnodeid: ele.pnodeid,
					nodename: ele.nodename,
					type: ele.type,
					describes: ele.describes,
					expscript: ele.expscript,
					sqlscript: ele.sqlscript,
          sqlscriptvalidate:ele.sqlscriptvalidate,
					FatherName: '顶级',
					icon: ele.type == 0 ? 'el-icon-search' : 'el-icon-folder',
				})
			} else {
				this.tree(ele, leaf)
			}
		});
	},
	getchildrenids: function(data, ids) {
		if (data.children instanceof Array) {
			data.children.forEach(item => {
				ids.push(item.id);
				this.getchildrenids(item, ids);
			})
		}
	},
	ipc_tree: function(d, leaf) {
		leaf.forEach(ele => {
			if (ele.ipccode === d.pipccode) {
				ele.children.push({
					id: d.ipccode,
					label: d.ipccode + '：' + d.ipcname,
					children: [],
					ipctypeid: d.ipctypeid,
					ipccode: d.ipccode,
					pipccode: d.pipccode,
					ipcname: d.ipcname,
					ipcfullname: d.ipcfullname,
					ipcremarken: d.ipcremarken,
					ipcfremark: d.ipcfremark,
					FatherName: ele.ipcname,
					FatherCode: ele.ipccode,
					icon: 'el-icon-document',
				})
				ele.icon = 'el-icon-folder';
			} else {
				this.ipc_tree(d, ele.children)
			}
		})
	},
	ipc_tree_init: function(d, leaf) {
		d.forEach(ele => {
			if (ele.pipccode == '') {
				leaf.push({
					id: ele.ipccode,
					label: ele.ipccode + '：' + ele.ipcname,
					children: [],
					ipctypeid: ele.ipctypeid,
					ipccode: ele.ipccode,
					pipccode: ele.pipccode,
					ipcname: ele.ipcname,
					ipcfullname: ele.ipcfullname,
					ipcremarken: ele.ipcremarken,
					ipcfremark: ele.ipcfremark,
					FatherName: '顶级',
					FatherCode: '',
					icon: 'el-icon-document',
				})
			} else {
				this.ipc_tree(ele, leaf)
			}
		});
	},
	encode64(input) {
		let base = new Base64();
		let output = base.encode(input);
		return output;
	}
};


// WEBPACK FOOTER //
// ./src/common/js/util.js